import { RuleDefinitions } from "src/components/types";
import "./RuleLinks.css";

type RuleLinksProps = {
  rules: RuleDefinitions | undefined;
};
export function RuleLinks({ rules }: RuleLinksProps) {
  let rulesLinks = [];

  if (!rules) {
    return <></>;
  }

  function handleRuleLinkClick(evt: React.MouseEvent<HTMLAnchorElement>) {
    evt.preventDefault();
    window.open((evt.target as HTMLAnchorElement).href, "Rulebook", "popup");
  }

  for (let rulesName in rules) {
    rulesLinks.push(
      <a href={rules[rulesName]} onClick={handleRuleLinkClick}>
        {rulesName}
      </a>,
    );
  }

  return <div className="rule-links-wrapper">{rulesLinks}</div>;
}
